import { render } from "./pinned-messages.vue?vue&type=template&id=91b839a0&scoped=true"
import script from "./pinned-messages.vue?vue&type=script&lang=js"
export * from "./pinned-messages.vue?vue&type=script&lang=js"

import "./pinned-messages.vue?vue&type=style&index=0&id=91b839a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b839a0"]])

export default __exports__